import { RadioGroup } from '@/components/ui/radio-group';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';
import { labels } from '@/locales/en.label';
import { PricingStrategy } from 'graphql/gql-types';
import { Info } from 'lucide-react';
import { StrategyCard } from './strategy-card';

const { pricing_strategy } = labels.rules;

const pricingStrategyOptions = [
	{
		label: 'Conservative',
		value: PricingStrategy.conservative,
		tooltip: pricing_strategy.conservative,
	},
	{
		label: 'Neutral',
		value: PricingStrategy.neutral,
		tooltip: pricing_strategy.neutral,
	},
	{
		label: 'Aggressive',
		value: PricingStrategy.aggressive,
		tooltip: pricing_strategy.aggressive,
	},
];

interface PricingStrategyFormProps {
	setFieldValue: (field: string, value: PricingStrategy) => void;
	pricingStrategy: PricingStrategy;
}

export const PricingStrategyForm = ({
	setFieldValue,
	pricingStrategy,
}: PricingStrategyFormProps) => {
	return (
		<div className='row'>
			<h2 className='header'>
				Pricing Strategy
				<TooltipProvider delayDuration={300}>
					<Tooltip>
						<TooltipTrigger asChild>
							<Info className='tw-inline tw-ml-1 tw-h-4 tw-w-4 tw-text-gray-400 tw-cursor-pointer' />
						</TooltipTrigger>
						<TooltipContent
							side='right'
							className='tw-max-w-xs tw-bg-white !tw-text-black tw-border tw-border-gray-200 tw-shadow-md tw-rounded tw-px-3 tw-py-2 tw-text-sm'
						>
							{pricing_strategy.info_tooltip}
							<br />
							<br />
							{pricing_strategy.info_tooltip_hint}
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>
			</h2>
			<RadioGroup
				value={pricingStrategy}
				defaultValue='neutral'
				className='tw-grid tw-grid-cols-3 tw-gap-4'
				onValueChange={(value: PricingStrategy) =>
					setFieldValue('pricingStrategy', value)
				}
				name='pricingStrategy'
			>
				{pricingStrategyOptions.map((option) => (
					<TooltipProvider key={option.value} delayDuration={500}>
						<Tooltip>
							<TooltipTrigger asChild>
								<StrategyCard value={option.value} label={option.label} />
							</TooltipTrigger>
							<TooltipContent
								side='bottom'
								className='tw-max-w-xs tw-bg-white !tw-text-black tw-border tw-border-gray-200 tw-shadow-md tw-rounded tw-px-3 tw-py-2 tw-text-sm'
							>
								{option.tooltip}
							</TooltipContent>
						</Tooltip>
					</TooltipProvider>
				))}
			</RadioGroup>
		</div>
	);
};
